import { useAuth } from "../../../usercontext";
import GlobalStudentLesson from "../../pages/common/globalstudentlessonforgrade";
import S12TopMenu from "../../student12/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import GlobalStudentLesson2 from "../../pages/common/globalstudentlesson2";
import { Nav, Tab } from "react-bootstrap";
import { useState } from "react";
import StudentCoursesReport from "../coursesreport";
import PageNotes from '../../pages/common/pagenotesnew'

export default function StudentLessons() {
	const { profile } = useAuth()
	const slug = profile.id
	const isStudent911 = profile?.role === 'Student911'
	const [activeTab, setActiveTab] = useState('listOfCourses')
	return (
		<>
			{!isStudent911 && <S12TopMenu slug={slug} activeMenu="Lessons" />}
			{isStudent911 && <S911TopMenu slug={slug} activeMenu="Lessons" />}
			<PageNotes type={'Student'} studentId={slug} />
			{/* <GlobalStudentLesson slug={slug} isStudent={true} /> */}
			{/* <GlobalStudentLesson2 slug={slug} isStudent={true} /> */}
			<Tab.Container defaultActiveKey="listOfCourses" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
				<Nav variant="tabs">
					<Nav.Item>
						<Nav.Link eventKey="listOfCourses">List of Courses</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link eventKey="courseReport">Course Report</Nav.Link>
					</Nav.Item>
				</Nav>
				<Tab.Content>
					<Tab.Pane eventKey="listOfCourses">
						<GlobalStudentLesson2 slug={slug} isStudent={true} />
					</Tab.Pane>
					<Tab.Pane eventKey="courseReport">
						<StudentCoursesReport />
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</>
	)
}
